
































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getColor } from '@/modules/_common/utils/getColor';

@Component({ name: 'NoAuth' })
export default class NoAuth extends BaseComponent {
  private store = store;

  getColor(status) {
    return getColor(status);
  }
}
